module.exports = __webpack_public_path__ + "static/media/Sankey diagram.65fdfe51.svg";